async function retrieveCourses() {
  try {
    const courseId = localStorage.getItem("currentC");

    const response = await fetch(
      `/apps/potato/get-course-videos?course_id=${courseId}`,
      {
        method: "POST",
        body: JSON.stringify({ course_id: courseId }),
      },
    );

    const data = await response.text();

    const result = JSON.parse(data);

    if (result) {
      return result;
    }

    return [];
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}

function createVideoRowInner(
  vimeoId,
  videoUrl,
  title,
  description,
  completed,
  isAcademy,
  previewUrl,
) {
  // Create the inner content of the video row
  const videoThumbnail = document.createElement("a");
  videoThumbnail.classList.add("video-thumbnail");
  if (completed) {
    videoThumbnail.classList.add("completed-border");
  }
  videoThumbnail.href = previewUrl;

  const width = 260;
  const height = 185;

  const thumbnailImage = document.createElement("img");
  thumbnailImage.src = `/apps/potato/vimeo/${vimeoId}`;
  thumbnailImage.alt = "video thumbnail";
  //   thumbnailImage.width = 230;
  //   thumbnailImage.height = 155
  thumbnailImage.width = width;
  thumbnailImage.height = height;

  videoThumbnail.appendChild(thumbnailImage);

  if (isAcademy) {
    const lockDiv = document.createElement("div");
    lockDiv.classList.add(
      completed ? "academy-lock-completed" : "academy-lock",
    );

    const lockIcon = document.createElement("span");
    lockIcon.classList.add("icon-wrapper");
    // Add the SVG content for the lock icon here

    lockDiv.appendChild(lockIcon);
    videoThumbnail.appendChild(lockDiv);
  }

  const watchLaterDiv = document.createElement("div");
  watchLaterDiv.classList.add("watch-later");

  const watchLaterIcon = document.createElement("span");
  watchLaterIcon.classList.add("icon-wrapper");
  // Add the SVG content for the watch later icon here

  watchLaterDiv.appendChild(watchLaterIcon);
  videoThumbnail.appendChild(watchLaterDiv);

  if (completed) {
    const completedDiv = document.createElement("div");
    completedDiv.classList.add("completed");

    const completedText = document.createElement("p");
    completedText.textContent = "Completed";

    completedDiv.appendChild(completedText);
    videoThumbnail.appendChild(completedDiv);
  }

  const videoInfo = document.createElement("div");
  videoInfo.classList.add("video-thumbnail-info");

  const videoTitle = document.createElement("p");
  videoTitle.classList.add("video-thumbnail-title");
  videoTitle.textContent = title;

  videoTitle.style.whiteSpace = "nowrap";
  videoTitle.style.overflow = "hidden";
  videoTitle.style.textOverflow = "ellipsis";
  videoTitle.style.maxWidth = `${width}px`;
  videoTitle.style.fontSize = "16px";
  videoTitle.style.fontWeight = "1000";

  const videoDescription = document.createElement("div");
  videoDescription.classList.add("video-thumbnail-description");

  const descriptionText = document.createElement("p");
  descriptionText.textContent = description;

  descriptionText.style.whiteSpace = "nowrap";
  descriptionText.style.overflow = "hidden";
  descriptionText.style.textOverflow = "ellipsis";
  descriptionText.style.maxWidth = `${width}px`;
  descriptionText.style.fontSize = "16px";

  const arrowIcon = document.createElement("span");
  arrowIcon.classList.add("icon-wrapper");
  // Add the SVG content for the arrow icon here

  videoDescription.appendChild(descriptionText);
  videoDescription.appendChild(arrowIcon);

  videoInfo.appendChild(videoTitle);
  videoInfo.appendChild(videoDescription);

  videoThumbnail.appendChild(videoInfo);

  return videoThumbnail;
}

async function populateMissingWeekVideos() {
  const weekContainers = document.querySelectorAll(".video-row-inner");
  const prerenderLoad = weekContainers.dataset?.prerendered === "true";

  if (prerenderLoad) {
    return;
  }

  const info = await retrieveCourses();

  info.forEach((week, index) => {
    const weekTitle = week.title;
    const videos = week.videos;

    const thumbnails = videos.map((video) => {
      const vimeoId = video.vurl.split("/")[5];
      const videoUrl = video.vurl ?? "#";
      const title = video.title ?? "Untitled Video";
      const description = video.info ?? "No description available";
      const completed = video.completed ?? false;
      const isAcademy = video.is_academy ?? false;
      const previewUrl = video.previewUrl ?? videoUrl;

      return createVideoRowInner(
        vimeoId,
        videoUrl,
        title,
        description,
        completed,
        isAcademy,
        previewUrl,
      );
    });

    // Append the thumbnails to the appropriate week container
    const weekContainer = weekContainers[index];
    if (weekContainer) {
      thumbnails.forEach((thumbnail) => {
        weekContainer.appendChild(thumbnail);
      });
    }
  });
}

populateMissingWeekVideos();

function handleVideoRowScrollButtons() {
  const videoRows = document.querySelectorAll(".video-row");
  for (const videoRow of videoRows) {
    const leftButton = videoRow.querySelector(".video-row-inner-left");
    const rightButton = videoRow.querySelector(".video-row-inner-right");
    const innerRow = videoRow.querySelector(".video-row-inner");

    leftButton.addEventListener("click", () => {
      console.log("Left button clicked");
      innerRow.scrollBy({ left: -300, behavior: "smooth" });
    });

    rightButton.addEventListener("click", () => {
      console.log("Right button clicked");
      innerRow.scrollBy({ left: 300, behavior: "smooth" });
    });
  }
}

handleVideoRowScrollButtons();
